import BaseService from '../base';

class Company extends BaseService {}

export default new Company('companies', 'Company');
